var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoCircle = function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8d33a6a8-c46d-4844-9cad-a004341b8d87a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8B8D98",
    fillRule: "evenodd",
    d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2M.667 8a7.333 7.333 0 1 1 14.666 0A7.333 7.333 0 0 1 .667 8m6.666-2.667c0-.368.299-.666.667-.666h.007a.667.667 0 1 1 0 1.333H8a.667.667 0 0 1-.667-.667m.667 2c.368 0 .667.299.667.667v2.667a.667.667 0 1 1-1.334 0V8c0-.368.299-.667.667-.667",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "8d33a6a8-c46d-4844-9cad-a004341b8d87a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgInfoCircle;